import data from "./programs.json";

export const SITE_URL = data.siteUrl;
export const GOOGLE_LISTING_URL = data.googleListingUrl;
export const organization = data.organization;
export const programs = data.programs;
export const prerenderPaths = Object.values(data.programs).map((program) => program.path);
